import { z } from 'zod'

export const recordEntitySchema = z.enum([
  'task',
  'order',
  'customer',
  'supplier',
  'internal_order',
  'engineering',
])
export type RecordEntity = z.infer<typeof recordEntitySchema>
export const documentCategorySchema = z.enum(['contract', 'invoice', 'drawing', 'photo', 'other'])
export type DocumentCategory = z.infer<typeof documentCategorySchema>
export const recordScopeSchema = z.object({
  entity: recordEntitySchema,
  entityId: z.string().min(1).max(200),
})
export const recordNoteSchema = recordScopeSchema
  .extend({
    text: z.string().trim().min(1).max(20_000),
    kind: z.enum(['note', 'call', 'email']).default('note'),
    mentions: z.array(z.string().min(1)).max(30).default([]),
    requestId: z.uuid(),
  })
  .strict()
export type RecordNoteInput = z.input<typeof recordNoteSchema>
export const recordUploadSchema = recordScopeSchema
  .extend({ category: documentCategorySchema.default('other'), requestId: z.uuid() })
  .strict()
export type RecordUploadInput = z.input<typeof recordUploadSchema>
export const recordFileRemoveSchema = z
  .object({ fileId: z.string().min(1), version: z.number().int().positive() })
  .strict()
export type RecordFileRemoveInput = z.infer<typeof recordFileRemoveSchema>
export interface RecordFile {
  id: string
  version: number
  name: string
  category: DocumentCategory
  kind: 'contract' | 'drawing' | 'other'
  sizeBytes: number
  sizeKb: number
  mimeType: string
  uploadedById: string
  uploadedAt: string
  downloadUrl: string | null
}
export interface RecordNote {
  id: string
  actorId: string | null
  kind: string
  text: string
  at: string
  mentions?: string[]
  file?: string
}
export interface RecordDocuments {
  files: RecordFile[]
  notes: RecordNote[]
}
